import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { taskListRequest } from '../../../redux/task/task.action'
import { shiftListRequest } from '../../../redux/shift/shift.action'
import moment from "moment";
import { isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import TopButton from "../../../components/button/top-button/topButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const TaskList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { taskListSuccess, taskListError } = useSelector(state => state.task)
    const { shiftListSuccess, shiftListError } = useSelector(state => state.shift)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const defaultTaskStatus = { key: 'ALL', value: removeSpecialCharAndChangeToPascal('ALL') }
    const assignedTaskStatus = { key: 'MY_TASKS', value: removeSpecialCharAndChangeToPascal('MY_TASKS') }
    const [taskStatusList, setTaskStatusList] = useState([
        defaultTaskStatus,
        { key: APP_CONSTANTS.TASK_STATUS.OPEN, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.OPEN) },
        { key: APP_CONSTANTS.TASK_STATUS.IN_PROGRESS, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) },
        { key: APP_CONSTANTS.TASK_STATUS.CLOSED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.CLOSED) },
        { key: APP_CONSTANTS.TASK_STATUS.HOLD, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.TASK_STATUS.HOLD) },
        assignedTaskStatus
    ])
    const [selectedStatus, setSelectedStatus] = useState(defaultTaskStatus)
    const [selectedShift, setSelectedShift] = useState()
    const [showShiftDropdown, setShowShiftDropdown] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.TASK_LIST, true)
            fetchBusinessList()
        }
    }, [])

    const fetchTaskList = () => {
        const data = {}
        if (!isEmpty(selectedStatus) && (selectedStatus.key !== 'ALL' && selectedStatus.key !== 'MY_TASKS')) {
            data.status = selectedStatus.key
        }
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness)) {
            data.businessId = selectedBusiness.businessId
        }
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedLocation)) {
            data.locationId = selectedLocation.locationId
        }

        if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        if (!isEmpty(selectedShift)) {
            data.shiftId = selectedShift.shiftId
        }
        if (!isEmpty(selectedStatus) && selectedStatus.key === 'MY_TASKS') {
            data.assignedUser = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.assignedType = user.data.userDetails.userType
        }
        setLoading(true)
        dispatch(taskListRequest(data))
    }

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.TASK_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.TASK_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(taskListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(taskListError)) {
            setLoading(false)
        }
    }, [taskListSuccess, taskListError])

    useEffect(() => {
        if (!isEmpty(shiftListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(shiftListError)) {
            setLoading(false)
        }
    }, [shiftListSuccess, shiftListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            fetchTaskList()
        }
    }, [selectedLocation])

    useEffect(() => {
        if (!isEmpty(selectedStatus)) {
            fetchTaskList()
        }
    }, [selectedStatus])

    useEffect(() => {
        if (!isEmpty(selectedShift)) {
            fetchTaskList()
        }
    }, [selectedShift])

    const getStatusClassName = (e, selectedStatus) => {
        if (e.key === 'ALL') {
            if (selectedStatus.key === 'ALL') {
                return 'tl-status-item tl-status-item-selected'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.TASK_STATUS.OPEN) {
            if (selectedStatus.key === APP_CONSTANTS.TASK_STATUS.OPEN) {
                return 'tl-status-item tl-status-item-selected-blue'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) {
            if (selectedStatus.key === APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) {
                return 'tl-status-item tl-status-item-selected-yellow'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.TASK_STATUS.CLOSED) {
            if (selectedStatus.key === APP_CONSTANTS.TASK_STATUS.CLOSED) {
                return 'tl-status-item tl-status-item-selected-green'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === APP_CONSTANTS.TASK_STATUS.HOLD) {
            if (selectedStatus.key === APP_CONSTANTS.TASK_STATUS.HOLD) {
                return 'tl-status-item tl-status-item-selected-red'
            } else {
                return 'tl-status-item'
            }
        } else if (e.key === 'MY_TASKS') {
            if (selectedStatus.key === 'MY_TASKS') {
                return 'tl-status-item tl-status-item-selected-dark-green'
            } else {
                return 'tl-status-item'
            }
        }
    }

    const handleFilterClick = () => {
        fetchShiftList()
        setShowShiftDropdown(true)
    }

    const handleFilterCancelClick = () => {
        setSelectedShift(undefined)
        setShowShiftDropdown(false)
    }

    const fetchShiftList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user) && !isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            data.businessId = selectedBusiness.businessId
            data.locationId = selectedLocation.locationId
        }
        if (isLoggedInUserEmployee(user) && !isEmpty(employeeSelectedBusiness) && !isEmpty(employeeSelectedLocation)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        dispatch(shiftListRequest(data))
    }

    const handleAddTaskClick = () => {
        navigate(ROUTES.task.add)
    }

    const getStatusColor = (status) => {
        if (status === APP_CONSTANTS.TASK_STATUS.OPEN) {
            return 'tl-status-label-blue'
        } else if (status === APP_CONSTANTS.TASK_STATUS.CLOSED) {
            return 'tl-status-label-green'
        } else if (status === APP_CONSTANTS.TASK_STATUS.HOLD) {
            return 'tl-status-label-red'
        } else if (status === APP_CONSTANTS.TASK_STATUS.IN_PROGRESS) {
            return 'tl-status-label-yellow'
        } else {
            return 'tl-status-label-dark-green'
        }
    }

    const handleViewDetail = (item) => {
        navigate(ROUTES.task.detail, {
            state: {
                taskId: item.taskId,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
            }
        })
    }

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.TASK.ADD_TASK) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.TASK, PERMISSION_SUB_TYPE.TASK.ADD_TASK, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Tasks' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                <div className="tl-status-row-container">
                    {!isEmpty(taskStatusList) && <div className="tl-status-parent-container">
                        <div className="tl-status-container">
                            {taskStatusList.map(e => (
                                <div className={getStatusClassName(e, selectedStatus)} onClick={() => setSelectedStatus(e)}>{e.value}</div>
                            ))}
                        </div>
                    </div>}
                    <div className="ol-search-icon-container" onClick={() => { handleFilterClick() }}>
                        <img src={require('../../../assets/ic_filter.png')} className="img" />
                    </div>
                </div>
                {showShiftDropdown && <div className="tl-shift-dd-parent-container">
                    <div className="tl-shift-dd-container">
                        {!isEmpty(shiftListSuccess) && !isEmpty(shiftListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedShift}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={shiftListSuccess.data}
                            placeholder='Select Shift'
                            onChange={e => setSelectedShift(e)} />}
                        {!isEmpty(shiftListError) && <div className="content-error">{shiftListError.message}</div>}
                    </div>
                    <div className="tl-clear-btn" onClick={() => { handleFilterCancelClick() }}>Clear</div>
                </div>}
                {!isNull(taskListSuccess) && !isEmpty(taskListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Created By</th>
                                <th scope="col" className="text-center">Assigned To</th>
                                {(!isEmpty(selectedStatus) && (selectedStatus.key === 'ALL' || selectedStatus.key === 'MY_TASKS')) && <th scope="col" className="text-center">Status</th>}
                                <th scope="col" className="text-center">Shift</th>
                                <th scope="col" className="text-center">Created Date</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {taskListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.title}</td>
                                    <td className="text-center">{!isEmpty(element.createdByDetails) ? `${element.createdByDetails.firstName} ${element.createdByDetails.lastName}` : '-'}</td>
                                    <td className="text-center">{!isEmpty(element.assignedUserDetails) ? `${element.assignedUserDetails.firstName} ${element.assignedUserDetails.lastName}` : '-'}</td>
                                    {(!isEmpty(selectedStatus) && (selectedStatus.key === 'ALL' || selectedStatus.key === 'MY_TASKS')) && <td className="text-center">
                                        <div className={getStatusColor(element.status)}>{removeSpecialCharAndChangeToPascal(element.status)}</div>
                                    </td>}
                                    <td className="text-center">{!isEmpty(element.shiftDetails) ? element.shiftDetails.name : '-'}</td>
                                    <td className="text-center">{moment.utc(element.createdOn).local().format('DD/MM/YYYY')}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(taskListError) && <div className="content-error">{taskListError.message}</div>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.TASK.ADD_TASK) &&
                    <div className="vl-fab-container" onClick={() => handleAddTaskClick()}>
                        <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default TaskList